import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';


import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { de } from 'date-fns/locale/de';

// Semantic UI
import { Form, FormGroup, FormInput, FormSelect, Button, Icon, Table, Modal, FormCheckbox } from 'semantic-ui-react';

// System data
import { mapRoomsToOptions } from "./systemdata";
import { optionsKontingent } from './systemdata';
import { optionsLockedOccupancies } from "./systemdata";
import { optionsInfants } from "./systemdata";

// Actions
import { doContractAction } from "./contractSlice";
import { setContractData } from "./contractSlice";

// Styles
import "react-datepicker/dist/react-datepicker.css";
import './contract.css';

//
registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @param {bool} editMode 
 * @returns 
 */
const Max2ContractSeasonRoomsRooms = ({ editMode }) => {
  // local State
  const [openNew, setOpenNew] = useState(false);
  const [newRoomCode, setNewRoomCode] = useState(null);
  const [newAllotmentStrg, setNewAllotmentStrg] = useState('X');
  const [newAllotmentRoom, setNewAllotmentRoom] = useState(null);
  const [newAllotmentMax, setNewAllotmenMax]    = useState('');
  
  // global State
  const dispatch = useDispatch();
  const Contract    = useSelector((state) => state.contract.data.Contract);
  const NewRoom     = {...useSelector((state) => state.contract.NewRoom)};
  const systemData  = useSelector((state) => state.app.systemData);  
    
  // i18n
  const { t } = useTranslation(); 

  // Edit mode?
  const readOnly = editMode ? false : true;

  // Systemdaten
  const derivedOptionsRoom = React.useMemo(() => {
    if (!systemData || !systemData['icmp006.system_zimmerart_neu']) return [];
    const rawData = systemData['icmp006.system_zimmerart_neu'] ?? [];
    return mapRoomsToOptions(rawData);
  }, [systemData]);

  // check if rooms defined
  if (typeof Contract?.Rooms === 'undefined' || !Contract?.Rooms.length) {
    return (
      <>
      <Button basic circular icon labelPosition='left' onClick={() => setOpenNew(true)}>
        <Icon name='add' />
        Zimmer hinzufügen
      </Button>
      </>
    )
  }

  
  // build options for referenc room select
  const optionsXRooms = Contract?.Rooms.map(room => {
    return { value: room.RoomCode, key: room.RoomCode, text: room.RoomCode + ' - ' + room.RoomName }
  });

  // only numbers allowed in allotment max input
  const handleKeyPress = (e) => {
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  //
  const handleAddNewRoom = () => {
    
    // get room name
    let room_name = '';
    derivedOptionsRoom.forEach(option => {
      if (option.value === newAllotmentRoom)  {
        room_name = option.text;
      }
    });
    
    // fill new room object 
    NewRoom.RoomCode = newRoomCode;
    NewRoom.RoomName = room_name;
    NewRoom.Allotment = { Type: newAllotmentStrg, ReferenceCode: newAllotmentRoom, Limit: newAllotmentMax };

    // reset values
    setNewRoomCode(null);
    setNewAllotmentStrg('X');
    setNewAllotmentRoom(null);
    setNewAllotmenMax('');

    //
    dispatch(doContractAction({target: 'Room.addRoom', value: NewRoom}))
    setOpenNew(false);
  }


  if (readOnly) {
    return (
      <Table celled structured striped basic='very'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.roomType')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.shortcode')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.allotmentType')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.fullPaying')}</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">{t('contract.seasonRooms.rooms.header.pax')}</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">{t('contract.seasonRooms.rooms.header.adults')}</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">{t('contract.seasonRooms.rooms.header.children')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.lockedOccupancies')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.adultOnly')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.infants')}</Table.HeaderCell>
            {!readOnly && (
              <Table.HeaderCell rowSpan="2"></Table.HeaderCell>
            )}
          </Table.Row>
          <Table.Row>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.min')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.max')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.min')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.max')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.min')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.max')}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Contract.Rooms.map((room, roomKey)=>(
            <Table.Row key={room.RoomCode}>
              <Table.Cell>{room.RoomName}</Table.Cell>
              <Table.Cell>{room.RoomCode}</Table.Cell>
              <Table.Cell>{room.Allotment.Type === 'BASIC' ? t('contract.seasonRooms.rooms.allotment.basic') : room.Allotment.Type === 'PARTIAL' ? t('contract.seasonRooms.rooms.allotment.partial', { ref: room.Allotment.ReferenceCode }) : t('contract.seasonRooms.rooms.allotment.maxPartial', { limit: room.Allotment.Limit, ref: room.Allotment.ReferenceCode })}</Table.Cell>
              <Table.Cell>{room.Occupancy.FullPaying}</Table.Cell>
              <Table.Cell>{room.Occupancy.PaxMin}</Table.Cell>
              <Table.Cell>{room.Occupancy.PaxMax}</Table.Cell>
              <Table.Cell>{room.Occupancy.AdultMin}</Table.Cell>
              <Table.Cell>{room.Occupancy.AdultMax}</Table.Cell>
              <Table.Cell>{room.Occupancy.ChildrenMin}</Table.Cell>
              <Table.Cell>{room.Occupancy.ChildrenMax}</Table.Cell>
              <Table.Cell>{room.LockedOccupancies.join(', ')}</Table.Cell>
              <Table.Cell>
                <Form>
                  <FormGroup>
                    {room.AdultOnly.IsAdultOnly && (<Icon circular name='check' />)}
                    {room.AdultOnly.IsAdultOnly && (<span>{t('contract.seasonRooms.rooms.adultOnlyFrom', { age: room.AdultOnly.AdultAge })}</span>)}                    
                  </FormGroup>
                </Form>
              </Table.Cell>
              <Table.Cell>
                {optionsInfants.map(option => {
                  if (option.value === room.Infants) {
                    return <span key={option.value}>{option.text}</span>
                  }
                  return null;
                })}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  }




  return (
    <>
      <Table celled structured striped basic='very'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.roomType')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.shortcode')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.allotmentType')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.fullPaying')}</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">{t('contract.seasonRooms.rooms.header.pax')}</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">{t('contract.seasonRooms.rooms.header.adults')}</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">{t('contract.seasonRooms.rooms.header.children')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.lockedOccupancies')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.adultOnly')}</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">{t('contract.seasonRooms.rooms.header.infants')}</Table.HeaderCell>
            {!readOnly && (
              <Table.HeaderCell rowSpan="2"></Table.HeaderCell>
            )}
          </Table.Row>
          <Table.Row>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.min')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.max')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.min')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.max')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.min')}</Table.HeaderCell>
          <Table.HeaderCell>{t('contract.seasonRooms.rooms.header.max')}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Contract.Rooms.map((room, roomKey)=>(
            <Table.Row key={room.RoomCode}>
              <Table.Cell>{room.RoomName}</Table.Cell>
              <Table.Cell>{room.RoomCode}</Table.Cell>
              <Table.Cell>{room.Allotment.Type === 'BASIC' ? t('contract.seasonRooms.rooms.allotment.basic') : room.Allotment.Type === 'PARTIAL' ? t('contract.seasonRooms.rooms.allotment.partial') : t('contract.seasonRooms.rooms.allotment.maxpartial')}</Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.FullPaying}  onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.FullPaying', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.PaxMin}      onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.PaxMin', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.PaxMax}      onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.PaxMax', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.AdultMin}    onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.AdultMin', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.AdultMax}    onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.AdultMax', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.ChildrenMin} onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.ChildrenMin', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.ChildrenMax} onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.ChildrenMax', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormSelect readOnly={readOnly} multiple className="uiselect_small" options={optionsLockedOccupancies} value={room.LockedOccupancies} placeholder={t('contract.seasonRooms.rooms.choose')} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.LockedOccupancies', value: data.value}))} /></Table.Cell>
              <Table.Cell>
                <Form>
                  <FormGroup>
                    <FormCheckbox toggle checked={room.AdultOnly.IsAdultOnly ? true : false} onClick={() => { if (!readOnly) { dispatch(setContractData({roomKey: roomKey, target: 'Rooms.AdultOnly.IsAdultOnly', value: !room.AdultOnly.IsAdultOnly}))}}} />
                    {room.AdultOnly.IsAdultOnly && (
                      <FormInput readOnly={readOnly} type="number" className="small" maxLength={2} onKeyPress={handleKeyPress} style={{width: "50px"}} value={room.AdultOnly.AdultAge} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.AdultOnly.AdultAge', value: parseInt(data.value)}))} />
                    )}                    
                  </FormGroup>
                </Form>
              </Table.Cell>
              <Table.Cell><FormSelect search readOnly={readOnly} className="uiselect_small" options={optionsInfants} value={room.Infants} placeholder={t('contract.seasonRooms.rooms.choose')} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Infants', value: data.value}))} /></Table.Cell>
              {!readOnly && (
                <Table.Cell>
                    <Button basic circular icon>
                      <Icon name='trash' onClick={() => dispatch(doContractAction({target: 'Room.delRoom', value: roomKey}))} />
                    </Button>
                </Table.Cell>
              )}
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      {!readOnly && (
        <Button basic circular icon labelPosition='left' onClick={() => setOpenNew(true)}>
            <Icon name='add' />
            {t('contract.seasonRooms.rooms.addRoom')}
        </Button>
      )}
  
      <Modal size="tiny" open={openNew} onClose={() => setOpenNew(false)}>
        <Modal.Header>{t('contract.seasonRooms.rooms.modal.title')}</Modal.Header>
        <Modal.Content>
          <Form>
            <FormSelect search selection label={t('contract.seasonRooms.rooms.modal.roomType')} options={derivedOptionsRoom} value={newRoomCode} placeholder={t('contract.seasonRooms.rooms.choose')} onChange={(_, data) => setNewRoomCode(data.value)} />
            <FormSelect search selection label={t('contract.seasonRooms.rooms.modal.allotmentControl')} options={optionsKontingent} value={newAllotmentStrg} placeholder={t('contract.seasonRooms.rooms.modal.allotmentControlPlaceholder')} onChange={(_, data) => setNewAllotmentStrg(data.value)} />
            {(newAllotmentStrg === 'T' || newAllotmentStrg === 'K') && (
              <FormGroup>
                <FormSelect search selection label={t('contract.seasonRooms.rooms.modal.baseRoom')} options={optionsXRooms} value={newAllotmentRoom} placeholder={t('contract.seasonRooms.rooms.modal.baseRoomPlaceholder')} onChange={(_, data) => setNewAllotmentRoom(data.value)} />
                {newAllotmentStrg === 'K' && (
                  <FormInput type="number" label={t('contract.seasonRooms.rooms.modal.maxAllotment')} maxLength={3} value={newAllotmentMax} placeholder={t('contract.seasonRooms.rooms.modal.maxAllotment')} onKeyPress={handleKeyPress} onChange={(_, data) => setNewAllotmenMax(parseInt(data.value))} />
                )}
              </FormGroup>
            )}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic circular icon labelPosition='left' onClick={() => setOpenNew(false)}>
            <Icon name='times' />
            {t('contract.seasonRooms.rooms.modal.cancel')}
          </Button>
          <Button primary circular icon labelPosition='left' onClick={() => handleAddNewRoom()}>
            <Icon name='plus' />
            {t('contract.seasonRooms.rooms.modal.add')}
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Max2ContractSeasonRoomsRooms;